import { render, staticRenderFns } from "./PopupShare.vue?vue&type=template&id=171afc78&scoped=true"
import script from "./PopupShare.vue?vue&type=script&lang=js"
export * from "./PopupShare.vue?vue&type=script&lang=js"
import style0 from "./PopupShare.vue?vue&type=style&index=0&id=171afc78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171afc78",
  null
  
)

export default component.exports